export const MESSAGE_ERREUR_VALEUR_POSITIF = "La valeur doit être numérique et supérieur à 0";
export const MESSAGE_ERREUR_ENTIER_VALEUR_POSITIF = "La valeur doit être un entier et supérieur à 0";